const base=window.Shopify?.routes?.root||'/';
const channel=document.body.dataset.commerceChannel;
const commerceContext={
  commerce_channel:channel,
  page_path:window.location.pathname,
  company_location:document.body.dataset.companyLocation||null
};
function publishCommerceContext(){
  const publish=window.Shopify?.analytics?.publish;
  if(typeof publish!=='function')return false;
  publish('decolab:commerce_context',commerceContext);
  return true;
}
if(!publishCommerceContext())window.addEventListener('load',publishCommerceContext,{once:true});
const say=message=>document.querySelectorAll('[data-commerce-status]').forEach(el=>el.textContent=message);
async function cartRequest(path,body){
  const response=await fetch(`${base}${path}`,{method:body?'POST':'GET',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
  if(!response.ok)throw new Error('Não foi possível conferir o carrinho. Tente novamente.');return response.json();
}
async function clearCart(){
  const cart=await cartRequest('cart/clear.js',{});
  if(cart.item_count!==0)throw new Error('O carrinho não foi esvaziado. Confira antes de mudar de ambiente.');
  await cartRequest('cart/update.js',{attributes:{decolab_order_channel:'',decolab_company_location:''},discount:''});
}
document.addEventListener('click',async event=>{
  const exit=event.target.closest('[data-commerce-exit]'),reset=event.target.closest('[data-commerce-reset]');
  const button=exit||reset;if(!button)return;event.preventDefault();if(button.dataset.busy)return;
  button.dataset.busy='true';
  try{
    const cart=await cartRequest('cart.js');
    if(cart.item_count>0&&!window.confirm(exit?'Para sair do atacado, este carrinho será esvaziado. Nenhum pedido será enviado. Deseja continuar para o varejo?':'Esvaziar este carrinho e começar uma nova compra no ambiente atual?'))return;
    await clearCart();
    // Never carry a B2B selection or checkout link into the personal purchase.
    try{sessionStorage.removeItem('decolab-b2b-selection-v1');sessionStorage.removeItem('decolab-b2b-selection-'+document.body.dataset.companyLocation);}catch{/* optional storage */}
    if(exit){window.location.assign(exit.href);return;}
    window.location.assign(channel==='b2b'?`${base}pages/seja-um-parceiro-decolab`:base);
  }catch(error){say(error.message);window.alert(error.message);}finally{delete button.dataset.busy;}
});
// A different tab can sign in/out; reload only when the authenticated context changed.
let away=false;
async function refreshContext(){
  try{
    const response=await fetch(`${base}?section_id=decolab-commerce-state`,{headers:{Accept:'text/html'},cache:'no-store'});
    if(!response.ok)return;
    const node=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-commerce-context-state]');
    if(!node)return;
    const fresh=JSON.parse(node.textContent);
    if(fresh.channel!==channel||fresh.location!==document.body.dataset.companyLocation)window.location.reload();
  }catch{/* Retry on the next page navigation, without discarding form data. */}
}
document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='hidden')away=true;else if(away){away=false;void refreshContext();}});
window.addEventListener('pageshow',event=>{if(event.persisted)void refreshContext();});
